<!--
* UIID: UI-CAAS-COM-100
* UI Name: Company List in the top bar
* Modify Date: 2020/06/22
-->
<template>
  <div class="container-Companylist">
    <v-menu
      offset-y
      allow-overflow
      min-width="380px"
      min-height="290px"
      max-height="800px"
      shaped
      :close-on-content-click="false"
      :close-on-click="closeOnClick"
      :nudge-bottom="4"
      transition="slide-y-transition"
    >
      <template v-slot:activator="{ on, value }">
        <v-btn class="btn-companylist" v-on="on" small text>
          <div v-if="repoActive" class="d-flex">
            <icon-svg size="20" iconName="Repository Manager" />
            <span class="mr-2">Repository</span>
            <v-icon x-small :class="`${value ? 'fa-rotate-180' : ''}`">fa fa-chevron-down</v-icon>
          </div>
          <div v-else>
            <v-avatar
              :color="getColorFromText(getCompIdName)"
              size="20"
              class="font-extrabold font-avatar bg-blur mr-2"
              >{{ getCompIdName.substring(0, 1) }}</v-avatar
            >
            <span class="pr-2">{{ getCompIdName }}</span>
            <v-icon x-small :class="`${value ? 'fa-rotate-180' : ''}`">fa fa-chevron-down</v-icon>
          </div>
        </v-btn>
      </template>
      <v-card class="popup-company" @click.stop :ripple="false">
        <v-data-iterator
          :search="search"
          :items="getItems"
          :items-per-page="getItems.length"
          hide-default-footer
        >
          <template v-slot:header>
            <v-row
              class="mt-5 mb-5"
              no-gutters
              v-if="$cookies.get('user-admin-yn-origin') === 'Y' || owerIdOld === chgComp.ownrId"
            >
              <v-col cols="12" class="pt-0 pb-0 pl-0 pr-0">
                <v-text-field
                  v-model="search"
                  heigth="30"
                  placeholder="Search"
                  single-line
                  dense
                  solo
                  class="data-table-filter-text-field custom-form-control border-search-popup"
                  hide-details
                  @click.stop="onFilterCompanies"
                  @input="onFilterCompanies"
                >
                  <template v-slot:append>
                    <span
                      style="cursor: pointer;"
                      class="clear-search-popup"
                      small
                      text
                      icon
                      @click="clearFunction"
                    >
                      <icon-svg iconName="close" />
                    </span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row class="mt-2 mb-2" no-gutters v-else></v-row>
          </template>

          <template v-slot:default>
            <v-row v-if="isEnableRepo" class="btn-repository" no-gutters>
              <v-btn class="pl-0" depressed text @click="setRepomenuMode">
                <icon-svg size="24" iconName="Repository Manager" />
                <span class="pl-3">{{ $t('btn.company.repository') }}</span>
              </v-btn>
            </v-row>
            <v-row
              :class="[index == 0 ? 'list-company space-h40' : 'list-company']"
              v-for="(item, index) in companysToShow"
              :key="item"
              dense
            >
              <v-col cols="12" class="map-text-field inline-block-component pt-0 pb-0">
                <div>
                  <v-avatar
                    :color="getColorFromText(getItems[item - 1].compNm)"
                    size="20"
                    class="font-extrabold font-avatar bg-blur mb-1"
                    >{{ getItems[item - 1].compNm.substring(0, 1) }}</v-avatar
                  >
                </div>

                <v-list-item-title height="20px">
                  <v-btn
                    height="20px"
                    text
                    ripple
                    class="btn"
                    block
                    @click="setCompanyInfo(getItems[item - 1])"
                  >
                    {{ getItems[item - 1].compNm }}
                    <v-spacer></v-spacer>
                    <font :style="getOwnrIdColor">({{ getItems[item - 1].ownrId }})</font>
                  </v-btn>
                </v-list-item-title>
                <div class="mr-2">
                  <v-list-item-title height="20px" v-if="getItems[item - 1].agentCnt > 0">
                    <v-icon :class="getStatusColor(getItems[item - 1].useSts) + `--text`" x-small
                      >fa fa-database</v-icon
                    >
                  </v-list-item-title>
                </div>
                <div class="mr-2">
                  <v-list-item-title height="20px">
                    <v-icon x-small :class="getStatusColor(getItems[item - 1].useSts) + `--text`"
                      >far fa-envelope</v-icon
                    >
                  </v-list-item-title>
                </div>
                <div>
                  <dropdownMenu
                    :dataValue="getItems[item - 1]"
                    :items="items"
                    @click-event="onClickMenu($event)"
                    @disable-close="disableClose()"
                    @enable-close="enableClose()"
                    @refreshList="searchData"
                  />
                </div>
              </v-col>
            </v-row>
          </template>

          <template v-slot:footer>
            <v-row dense>
              <v-col cols="12" class="footer-company-list">
                <v-row no-gutters>
                  <v-row v-if="getItems.length > 5" class="pt-0 pb-0 no-gutters mr-1">
                    <v-btn
                      text
                      small
                      v-if="companysToShow < getItems.length && disableCollape"
                      @click.stop="expandAllCompany()"
                      >Expand</v-btn
                    >
                    <v-btn
                      text
                      small
                      v-if="companysToShow >= getItems.length && disableCollape"
                      @click.stop="collapseCompany()"
                      >Collapse</v-btn
                    >
                  </v-row>
                  <companyDetailWindow
                    v-if="$cookies.get('user-admin-yn-origin') === 'Y'"
                    title="Create Company"
                    btnTxt="Create new company"
                    class="no-gutters created-align"
                    @close-check="closeCheck"
                    @refreshList="searchData"
                  ></companyDetailWindow>
                </v-row>
              </v-col>
            </v-row>
          </template>
        </v-data-iterator>
      </v-card>
    </v-menu>
    <dialogWindow
      ref="ChangeComp"
      title="Changing Company"
      :info="tempComp.compNm"
      size="max"
      :detail="$t('msg.company.confirmChangeCompany')"
      color="confirmation"
      :showCancel="true"
      @select-ok="sessionChangeOk(tempComp)"
    ></dialogWindow>
    <dialogWindow
      ref="changeRepoComp"
      title="Changing Repository"
      size="max"
      :detail="$t('msg.company.confirmChangeRepoCompany')"
      color="confirmation"
      :showCancel="true"
      @select-ok="sessionChangeRepo()"
    ></dialogWindow>
    <dialogWindow
      ref="removeComp"
      size="max"
      :detail="checkDialogInfo"
      color="success"
      @select-ok="removeDialog()"
    ></dialogWindow>
    <dialogWindow
      ref="sessionExpiredDialog"
      color="alert"
      :detail="seDialogInfo"
      @select-ok="logoutDialog()"
    ></dialogWindow>
  </div>
</template>

<script>
import dropdownMenu from '@/vue-caas/views/company/CompanyDropdownMenu.vue';
import companyDetailWindow from '@/vue-caas/views/company/CompanyDetail.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';

import config from '@/vue-caas/config/config.js';

export default {
  components: {
    dropdownMenu,
    companyDetailWindow,
    dialogWindow,
    IconSvg,
  },
  data: () => ({
    search: '',
    values: [],
    closeOnClick: true,
    expandata: false,
    disableCollape: true,
    items: [
      { content: 'Modify', icon: 'fa fa-edit', code: 'E' },
      { content: 'Remove', icon: 'fa fa-trash-alt', code: 'D' },
      { content: 'Agent', icon: 'fa fa-database', code: 'A' },
    ],
    compIdTxt: '',
    checkDialogInfo: '',
    chgComp: {},
    tempComp: {},
    compList: [],
    isEnableRepo: false,
    repoActive: false,
    seDialogInfo: '',
    owerIdOld: '',
  }),
  mounted() {
    window.addEventListener('storage', (event) => {
      if (event.key === 'processSharedData') {
        const updatedState = JSON.parse(event.newValue);
        if (updatedState?.COMP) {
          this.searchData();
        }
      }
    });
  },
  created() {
    this.compIdTxt = $cookies.get('comp-name');
    this.compId = $cookies.get('comp-id');
    this.owerIdOld = $cookies.get('ownr-id');
    this.searchData();
    // 2023.10.11
    if (this.$cookies.get('comp-repo-use-yn-origin') === 'Y') {
      this.$store.dispatch('getUser', { usrId: this.$cookies.get('user-id') }).then(() => {
        const menuListStr = this.$store.getters.user.menuAuth;
        const menuList = JSON.parse(menuListStr);
        menuList.forEach((item) => {
          if (item.name === 'Repository Manager' && !item.children) {
            if (item.select) {
              this.isEnableRepo = true;
            }
          }
          if (item.name === 'EDI Asset' && item.children.lenght != 0) {
            item.children.forEach((childItem) => {
              if (childItem.name === 'Repository Manager' && !childItem.children) {
                if (childItem.select) {
                  this.isEnableRepo = true;
                }
              }
            });
          }
        });
      });
    }
  },
  computed: {
    getItems() {
      this.compList = this.$store.getters.companies;
      if (this.chgComp?.compId != this.compList[0]?.compId) {
        this.compList = this.compList.filter((e) => e.compId != this.chgComp.compId);
      }
      return this.compList;
    },

    getCompIdName() {
      return this.compIdTxt;
    },
    getCompId() {
      return this.compId;
    },
    companysToShow() {
      if (this.getItems.length < 5 || this.expandata) {
        return this.getItems.length;
      } else if (!this.expandata) {
        return 5;
      }
      return 5;
    },
    getOwnrIdColor() {
      return this.$vuetify.theme.dark === true ? 'color:#777777' : 'color:#BBBBBB';
    },
  },
  watch: {
    isEnableRepo() {
      console.log('isEnableRepo', this.isEnableRepo);
    },
  },
  methods: {
    clearFunction() {
      this.search = '';
      this.onFilterCompanies();
    },
    // 2021.3.16 203728 SPKA-52 => bug 13
    closeCheck(obj) {
      this.closeOnClick = obj.value;
    },
    searchData() {
      // this.results = this.getCompanyList;
      this.$store.dispatch('getCompanyList').then(() => {
        Store.commit('common/setRepoMenuMode', false);
      });
    },
    // add by April for DLB  2020.06.10
    setCompanyInfo(item) {
      // Check session by session-manager application.
      const hash = $cookies.get('hash');
      this.$http.defaults.headers.common['hash'] = hash;
      this.$http
        .post(`${config.sessionApiUrl}/session/info`, { hash: hash })
        .then(() => {
          this.tempComp = item;
          this.$refs.ChangeComp.dialog = true;
        })
        .catch(() => {
          this.$refs.sessionExpiredDialog.dialog = true;
          this.seDialogInfo = 'Session expired.';
        });
    },

    logoutDialog() {
      this.$router.push('/login');
    },
    onClickMenu(item) {
      let value = item.value;

      if (item.code == 'D') {
        const currentComp = $cookies.get('comp-id');

        this.$store.dispatch('deleteCompany', value).then(() => {
          this.checkDialogInfo = `${value.compNm} has been removed successfully.`;
          this.$refs.removeComp.dialog = true;
          if (value.compId === currentComp) {
            this.sessionChangeOk(this.getItems[0]);
          }
        });
      }
    },
    removeDialog() {
      this.disableClose();
      this.$refs.removeComp.dialog = false;
      this.value = {};
      this.detailDialog = false;
    },
    getStatusColor(status) {
      if (status == 'C') {
        return 'success';
      } else {
        return 'warning';
      }
    },
    getColorFromText(text) {
      let colorCode = (
        text.charCodeAt(0) *
        text.charCodeAt(0) *
        text.charCodeAt(0) *
        text.charCodeAt(0) *
        0xffffff
      )
        .toString(16)
        .substring(0, 6);
      return '#' + colorCode;
    },
    getRandomColor() {
      return '#' + Math.round(Math.random() * 0xffffff).toString(16);
    },

    disableClose() {
      this.closeOnClick = false;
    },

    enableClose() {
      this.closeOnClick = true;
    },
    closeMenu() {
      this.expandata = false;
      this.search = '';
      this.onFilterCompanies();
    },

    sessionChangeOk(item) {
      const hash = $cookies.get('hash');
      this.$store
        .dispatch('membership/changeSession', {
          ownrId: item.ownrId,
          compId: item.compId,
          compNm: item.compNm,
          hash: hash,
        })
        .then(() => {
          const expiredTime = '7d';
          $cookies.set('comp-repo-use-yn', 'N', expiredTime); // Company권한 - Company용 Repository를 사용하는지 여부
          $cookies.set('comp-adminrepo-use-yn', 'Y', expiredTime); // Company권한 - Company가 Admin Repository를 사용하는지 여부
          $cookies.set('ownr-id', item.ownrId, expiredTime); // Company정보 - Owner ID
          $cookies.set('comp-id', item.compId, expiredTime); // Company정보 - Compony ID
          $cookies.set('comp-name', item.compNm, expiredTime); // Company정보 - Compony ID
          // 2021.5.17 203728 Add spFlg
          $cookies.set('user-admin-yn', item.spFlg, expiredTime); // Service Provider Flag
          this.compIdTxt = item.compNm;
          this.$emit('change-company', item.compNm);

          this.$refs.ChangeComp.dialog = false;
          // refresh page
          this.$emit('refresh-page', {
            timestamp: new Date().getTime(),
            url: this.$router.currentRoute.path,
          });
          Store.commit('common/setRepoMenuMode', false);
          // 2021.3.25 203728 SPKA-57 issue 26
          Store.commit('common/setCompanyForLeftMenu', item.compId);
          this.repoActive = false;
          this.chgComp = item;
        });
    },
    collapseCompany() {
      this.expandata = false;
    },
    expandAllCompany() {
      this.expandata = true;
    },
    onFilterCompanies() {
      if (this.search == '') {
        this.disableCollape = true;
      } else {
        this.disableCollape = false;
      }

      this.$store.commit('SET_STORE_COMP_LIST_Update', {
        value: this.search,
        ownr: $cookies.get('ownr-id'),
      });
    },
    setRepomenuMode() {
      this.$refs.changeRepoComp.dialog = true;
    },
    sessionChangeRepo() {
      Store.commit('common/setRepoMenuMode', true);
      this.$emit('refresh-page', {
        timestamp: new Date().getTime(),
        url: this.$router.currentRoute.path,
      });
      this.repoActive = true;
      this.$router.push('/ediasset/repository');
      this.$refs.changeRepoComp.dialog = false;
    },
  },
};
</script>

<style scoped>
.menu-list-height {
  max-height: 204px;
}
.bg-blur {
  -webkit-opacity: 0.8;
  -moz-opacity: 0.8;
  -o-opacity: 0.8;
  -ms-opacity: 0.8;
  opacity: 0.8;
}
.theme--dark .popup-company {
  background-color: #373b46;
  border-color: rgba(255, 255, 255, 0.12) !important;
}
.list-company {
  height: 20px !important;
  margin-bottom: 15px;
}
.list-company .inline-block-component {
  display: flex;
  line-height: 1.25;
}
.list-company .inline-block-component_line {
  display: flex;
  line-height: 1.25;
}

.space-h40 {
  height: 40px !important;
  border-bottom: 1px solid #7d838d;
}

.space-h40 .inline-block-component {
  padding-bottom: 19px !important;
}

.popup-company {
  padding: 0px 15px;
  border: 1px solid;
  cursor: default;
}
.footer-company-list {
  padding-top: 0px;
  padding-bottom: 14px;
}
.btn-companylist {
  padding-left: 0px !important;
  padding-right: 15px !important;
}
.container-Companylist {
  padding-left: 15px !important;
  border-color: red;
}
.theme--dark .footer-company-list >>> .v-btn__content {
  color: #0082ba !important;
  text-decoration: underline;
}
.list-company .v-list-item__title {
  height: 20px !important;
}
.created-align {
  justify-content: flex-end !important;
}
.list-company .btn {
  font-size: 13px;
}
.btn-repository {
  margin-bottom: 5px;
}
.font-avatar {
  font-size: 13px;
}
.v-menu__content::-webkit-scrollbar {
  width: 8px;
}
.theme--light .v-menu__content::-webkit-scrollbar-track {
  background-color: #ffffff;
}
.theme--light .v-menu__content::-webkit-scrollbar-corner {
  background-color: #ffffff;
}
.theme--light .v-menu__content::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
}
.theme--dark .v-menu__content::-webkit-scrollbar-track {
  background-color: #595b64;
}
.v-menu__content::-webkit-scrollbar-thumb {
  border-radius: 10px;
}
.theme--dark .v-menu__content::-webkit-scrollbar-thumb {
  background-color: #dedfe0;
}
.theme--dark .v-menu__content::-webkit-scrollbar-corner {
  background-color: #595b64;
}
.theme--dark .popup-company.v-card--link:before {
  background: #373b46;
}
.theme--light .popup-company.v-card--link:before {
  background: #ffffff;
}
</style>
